import { emptyValueIfNull } from './chart';

const formatLinksToGroupedTreemapChartData = (data, valueGetter) => {
  return data.map(({ type, links }) => ({
    id: type,
    name: type,
    value: links.length,
    children: links
      .map((link) => ({
        id: link.audienceSubheader,
        name: link.audienceSubheader,
        value: emptyValueIfNull(valueGetter(link)),
        link: link,
      }))
      .sort((a, b) => b.value - a.value),
  }));
};

export default formatLinksToGroupedTreemapChartData;
